<mat-toolbar color="primary" class="app__toolbar mat-elevation-z0">
    <span>
        <a class="console-link" routerLink="/console">ZoneIQ API Admin</a>
    </span>
    <div class="services-statuses-container">
        <app-sync-service-status></app-sync-service-status>
        <app-processes-status></app-processes-status>
        <app-settings-button class="settings-button-container"></app-settings-button>
    </div>
</mat-toolbar>
<div class="app__content-wrapper">
    <router-outlet></router-outlet>
</div>